import React, { useState } from "react";
import { TextField, Grid, Button } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DialogContentWrapper from "./Components/DialogContentWrapper";
import TableWithPagination from "./Components/TableWithPagination";

const AddGameDialog = ({
  addGameDialogOpen,
  handleCloseAddGameDialog,
  eventGameDetails,
  eventGameEditMode,
  setEventGameDetails,
  eventGameList,
  handleSaveEventGameDetails,
  handleEventGameEdit,
  handleEventGameDelete,
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Dynamic columns for the game list
  const columns = [{ label: "Game Name", field: "gameName", align: "left" }];

  return (
    <DialogContentWrapper
      open={addGameDialogOpen}
      onClose={handleCloseAddGameDialog}
      title="Create Game"
      //icon={<AddCircleOutlineIcon color="primary" sx={{ marginRight: 1 }} />}
    >
      <Grid container spacing={2} style={{ padding: "20px 24px" }}>
        <Grid item xs={6} sm={8}>
          <TextField
            label="Enter Game Name"
            variant="outlined"
            fullWidth
            size="small"
            value={eventGameDetails.gameName}
            onChange={(event) =>
              setEventGameDetails((prev) => ({
                ...prev,
                gameName: event.target.value,
              }))
            }
          />
        </Grid>
        <Grid item xs={6} sm={4}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSaveEventGameDetails(eventGameDetails)}
          >
            {eventGameEditMode ? "Update" : "Add"}
          </Button>
        </Grid>
      </Grid>
      <TableWithPagination
        title={"Game List"}
        columns={columns}
        rows={eventGameList}
        rowsPerPage={rowsPerPage}
        page={page}
        handlePageChange={(e, newPage) => setPage(newPage)}
        handleRowsPerPageChange={(e) =>
          setRowsPerPage(parseInt(e.target.value, 10))
        }
        handleEdit={handleEventGameEdit}
        handleDelete={handleEventGameDelete}
      />
    </DialogContentWrapper>
  );
};

export default AddGameDialog;
